import React from 'react'
import PropTypes from 'prop-types'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { Button } from 'shared/components'
import { useParams } from 'react-router'

import * as styles from './styles'

const controlTeamAthletesComponent = ({
  onAddAthleteToTeam,
  onRemoveAthleteFromTeam,
  value,
}) => {
  const { teamId } = useParams()

  const addButtonHandler = () => {
    onAddAthleteToTeam(value.id, +teamId)
  }

  const removeButtonHandler = () => {
    onRemoveAthleteFromTeam(value.id, +teamId)
  }

  return (
    <>
      {value.isAddedToTeam ? (
        <Button plain title="Remove athlete" onClick={removeButtonHandler}>
          <FontAwesomeIcon size="lg" icon="trash" css={styles.icon} />
        </Button>
      ) : (
        <Button plain title="Add athlete" onClick={addButtonHandler}>
          <FontAwesomeIcon size="2x" icon="plus-circle" />
        </Button>
      )}
    </>
  )
}

controlTeamAthletesComponent.propTypes = {
  onAddAthleteToTeam: PropTypes.func.isRequired,
  onRemoveAthleteFromTeam: PropTypes.func.isRequired,
}
export default controlTeamAthletesComponent
